export const ENDPOINTS = {
  AUTH: {
    SIGNUP: "/user-signup",
    LOGIN: "/user-login",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD: "/reset-password",
    VALIDATE_RESET_LINK: "/validate-reset-link",
    CHANGE_PASSWORD: "/change-password",
  },
  PROFILE: {
    UPDATE: "/profile-update",
  },
  CMS: {
    BANNER: "/fetch_bannerdetails",
    PAGES: "/Fetch_CmsDetails",
  },
  DATA_VISUALIZATION: {
    FILTER: "/getAnalyticalFilterOptions",
    CANCER_LIST: "/Display_CancerList",
    SELECTED_CANCER_TYPE: "/Display_Icc3CodeList",
    DISTRICT_LIST: "/Display_DistrictList",
    GET_ANALYTICAL_DATA: "/getAnalyticalData",
  },
  FACTSHEETS: {
    CANCER_LIST: "/Display_CancerList",
    SELECTED_CANCER_TYPE: "/Display_Icc3CodeList",
    DISTRICT_LIST: "/Display_DistrictList",
    FACTSHEET: "/factSheetVisualization",
  },
  HOSPITALS:{
    COLLABORATORS_LIST: "/Display_HospitalList",
  }
};
